/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet'
import {
  Divider,
  makeStyles,
  Typography,
  Grid,
  Link,
  IconButton,
  Breadcrumbs,
  Toolbar,
  Box,
  FormControl,
  InputLabel,
  Select,
} from '@material-ui/core';
import Footer from '../../components/layouts/Footer';
import {
  RoomOutlined as RoomOutlinedIcon,
  EventAvailableOutlined as EventAvailableOutlinedIcon,
  TrendingUpOutlined as TrendingUpOutlinedIcon,
  ConfirmationNumberOutlined as ConfirmationNumberOutlinedIcon,
  PeopleOutlineOutlined as PeopleOutlineOutlinedIcon,
  ShoppingCartOutlined as ShoppingCartOutlinedIcon,
  ArrowUpwardOutlined as ArrowUpwardOutlinedIcon,
  ArrowBackOutlined as ArrowBackOutlinedIcon
} from '@material-ui/icons';

import { getMetabaseReports, getMetabaseReportEmbedUrl } from '../../services/reportService';
import userService from '../../services/userService';
import Notification from "../../components/Notification";
import Cookies from "universal-cookie";

const cookies = new Cookies();
// Bounded, definite height so the iframe fills it (scrolls internally for tall dashboards)
// and the Footer flows below instead of being overlapped by a fixed-height iframe.
// Fill the viewport below the top bar so the report uses the available space instead of
// floating in a small frame; bare-minimum padding keeps it neat.
const viewerStyle = { width: '100%', height: 'calc(100vh - 140px)', padding: 8, boxSizing: 'border-box' };

const drawerWidth = 250;
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  content: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
  },
  drawerPaper: {
    width: drawerWidth,
  },
  toolbar: theme.mixins.toolbar,
  Toolbar: {
    width: '50% !important',
    padding: '0px',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
    },
  },
  borderOutline: {
    padding: 20,
    marginRight: 10,
    marginBottom: 10,
    borderRadius: 8,
    boxShadow: 'none !important',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    flexGrow: 1
  },
  smallTitle: {
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: -0.5,
    textAlign: 'left',
    color: '#878787',
  },
  smallText: {
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: -0.2,
    color: '#323232',
  },
  revenueTicketsStyle: {
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: 32,
    letterSpacing: -0.5,
    color: '#323232',
  },
  redIcon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: 20,
    gap: 10,
    width: 64,
    height: 64,
    background: 'rgba(255, 255, 255, 0.2)',
    color: '#9D1B33',
    border: '1px solid #9D1B33',
    borderRadius: 8,
  },
  mediumHeading: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: -1,
    color: '#323232',
  },
  redLink: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 14,
    letterSpacing: -0.5,
    color: '#9D1B33',
  },
  formControl: {
    margin: 0,
    minWidth: 220,
  },
  topBar: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: theme.spacing(3),
    padding: theme.spacing(1.5, 1, 0.5),
  },
  topBarHeading: {
    marginBottom: theme.spacing(0.5),
  },
}))

function ReportViewer() {
  const currentUser = cookies.get('currentUser');
  const classes = useStyles();
  const [reportData, setReportData] = useState(null);
  const [accountid, setAccountID] = useState([]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [selectedAccountId, setSelectedAccountId] = useState(currentUser.accountid);
  const [selectedReport, setSelectedReport] = useState(null);
  const [embedUrl, setEmbedUrl] = useState(null);
  const [embedLoading, setEmbedLoading] = useState(false);

  const notification = (message, type) => {
    setNotify({
      isOpen: true,
      message: message,
      type: type,
    });
  };

  const errorHandle = (error) => {
    if (!error && !checkParam(Object.keys(error))) {
      notification(error, 'error');
    } else {
      const messages = (error.response) && !error.response.data.message ? error.response.data.error ? error.response.data.error : error.response.data : error.message;
      messages === "Invalid Token" ? timeOutSet() : notification(messages, 'error');
    }
  };

  const loadReports = async (accountid) => {
    try {
      const reportData = await getMetabaseReports(accountid);
      setReportData(reportData);
    } catch (error) {
      errorHandle(error);
    }
  };

  const handleChange = async (event) => {
    // The native <select> yields a string; report_master ids are numeric.
    const reportId = Number(event.target.value);
    const report = reportData.reports.find(t => t.reportId === reportId);
    setSelectedReport(report);
    setEmbedUrl(null);
    if (!report) return;
    try {
      setEmbedLoading(true);
      const iframeUrl = await getMetabaseReportEmbedUrl(report.reportId);
      setEmbedUrl(iframeUrl);
    } catch (error) {
      errorHandle(error);
    } finally {
      setEmbedLoading(false);
    }
  };

  const handleAccountChange = async (event) => {
    cookies.set('accountid', event.target.value);
    setSelectedAccountId(event.target.value);
    setReportData(null);
    setSelectedReport(null);
    setEmbedUrl(null);
    await loadReports(event.target.value);
  }

  useEffect(() => {
    userService.getUserAccounts()
      .then(userAccounts => {
        setAccountID([...userAccounts])
      })
      .catch((error) => {
        errorHandle(error);
      });
      loadReports(currentUser.accountid);
    }, []);

  return (
    <div>
      <Helmet title="Report View" />
      <main className={classes.content}>
        <div className={classes.topBar}>
          <Typography variant="h5" className={`breadcrumbs ${classes.topBarHeading}`}>Reports</Typography>
          {reportData && (
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="report-native-simple">Select a Report</InputLabel>
              <Select
                native
                onChange={handleChange}
                inputProps={{ name: 'report', id: 'report-native-simple' }}
              >
                <option aria-label="None" value="" />
                {reportData.reports.length > 0 && reportData.reports.map(op => (
                  <option key={op.reportId} value={op.reportId}>{op.name}</option>
                ))}
              </Select>
            </FormControl>
          )}
          {currentUser.roleid === 1 && accountid.length > 0 && (
            <select
              value={selectedAccountId}
              onChange={handleAccountChange}
              className="select-box mt-0 mb-0">
              <option value="0">Select Customer</option>
              {(accountid).map((v, k) => (
                v.roleid !== 1
                  ? <option key={k} id={k} value={v.accountid}>{v.accountname}</option>
                  : null
              ))}
            </select>
          )}
        </div>
        <Divider />

        {selectedReport && (
          <div style={viewerStyle}>
            {embedLoading && <Typography className={classes.smallText}>Loading report…</Typography>}
            {embedUrl && (
              <iframe
                title={selectedReport.name}
                key={selectedReport.reportId}
                src={embedUrl}
                frameBorder={0}
                style={{ width: '100%', height: '100%', border: 'none' }}
                allowtransparency="true"
              />
            )}
          </div>
        )}
      </main>

      <Notification notify={notify} setNotify={setNotify} />

      <Footer />
    </div>
  );
};

export default ReportViewer;